import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Conte sobre a sua organização',
  subtitle: 'Os atletas veem essas informações junto com o que a conta divulga no app.',
  editTitle: 'Editar dados da organização',
  editSubtitle: 'Corrija o que for preciso e envie de novo para a análise.',
  steps: {
    organization: 'Organização',
    contact: 'Contato e região',
    review: 'Revisão',
  },
  next: 'Continuar',
  back: 'Voltar',
  later: 'Fazer depois',
  cancel: 'Cancelar',
  submit: 'Enviar para análise',
  resubmit: 'Salvar e reenviar',
  created: 'Conta enviada para análise',
  saved: 'Dados enviados para análise',
  submitError: 'Não foi possível enviar os dados, tente de novo',
} satisfies TranslationTree;
